import React, { useEffect, useState } from 'react'
import { useParams, useLocation, useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import {
  surveyType,
  useErrorService,
  PrintableArea,
  buildQuarterAssessmentFileBase,
  formatQuarterFileLabel,
} from '@abroad/components'
import {
  WisdomAssessmentResult,
  ProsperityAssessmentResult,
  AwarenessAssessmentResult,
} from '../components'
import API from '../utils/API'

const EcosystemDateSurveyResult = () => {
  let { search } = useLocation()
  const { ecoSystemName } = useParams()
  let history = useHistory()
  const Error = useErrorService()
  const [survey, setSurvey] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const query = new URLSearchParams(search)
  const year = query.get('year')
  const quarter = query.get('quarter')
  const startDate = query.get('startDate')
  const endDate = query.get('endDate')
  const querySurveyType = query.get('surveyType')
  const pdfFileNameBase =
    quarter && year
      ? buildQuarterAssessmentFileBase(
          ecoSystemName,
          formatQuarterFileLabel(quarter, year),
          querySurveyType,
        )
      : undefined

  useEffect(() => {
    const getComparion = async () => {
      try {
        const { data } =
          await API.AdminAPI.companyList.getSurveyDateByEcosystem(
            ecoSystemName,
            search,
          )
        setSurvey(data)
        setIsLoading(false)
      } catch (e) {
        if (
          e?.code === 'ValidationError' ||
          e?.code === 'resource_not_found' ||
          e?.code === 'not_found'
        ) {
          history.replace('/404')
        } else {
          setIsLoading(false)
          Error.showError(e)
        }
      }
    }
    if (((year && quarter) || (startDate && endDate)) && ecoSystemName) {
      getComparion()
    } else {
      history.replace('/admin/home')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <title>{`${ecoSystemName}'s Survey Result | Abroad`}</title>
        <meta
          name='title'
          content={`${ecoSystemName}'s Survey Result | Abroad`}></meta>
        <meta
          property='og:title'
          content={`${ecoSystemName}'s Survey Result | Abroad`}></meta>
        <meta
          property='twitter:title'
          content={`${ecoSystemName}'s Survey Result | Abroad`}></meta>
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/admin/networks`}></link>
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/admin/networks`}></meta>
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/admin/networks`}></meta>
      </Helmet>
      <main>
        {querySurveyType === surveyType.WISDOM ? (
          <WisdomAssessmentResult
            survey={survey}
            isLoading={isLoading}
            headerText='Network Wisdom Assessment'
            subHeaderText={`${decodeURIComponent(
              ecoSystemName,
            ).toUpperCase()}'S COMBINED SUMMARY RESULTS`}
            subHeaderDescription='Below are the aggregate results for how all participants within Network rated their organizations and themselves during the specified time period'
            pdfFileNameBase={pdfFileNameBase}
          />
        ) : querySurveyType === surveyType.PROSPERITY ? (
          <ProsperityAssessmentResult
            survey={survey}
            isLoading={isLoading}
            headerText='Network TrueProsperity Assessment'
            subHeaderText={`${decodeURIComponent(
              ecoSystemName,
            ).toUpperCase()}'S COMBINED SUMMARY RESULTS`}
            subHeaderDescription='Below are the aggregate results for how all participants within Network rated their organizations and themselves during the specified time period'
            pdfFileNameBase={pdfFileNameBase}
          />
        ) : (
          <AwarenessAssessmentResult
            survey={survey}
            isLoading={isLoading}
            headerText='Network Awareness Assessment'
            subHeaderText={`${decodeURIComponent(
              ecoSystemName,
            ).toUpperCase()}'S COMBINED SUMMARY RESULTS`}
            subHeaderDescription='Below are the aggregate results for how all participants within Network rated their organizations and themselves during the specified time period'
            pdfFileNameBase={pdfFileNameBase}
          />
        )}
      </main>
      <PrintableArea printSelector='main' />
    </>
  )
}

export default EcosystemDateSurveyResult
